import React, { useRef, useState } from "react";
import { Container, Row, Col, Card, Button, FloatingLabel, Form, Alert } from 'react-bootstrap';
import emailjs from "@emailjs/browser";


export const ContactUs = () => {
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_qdjkp3r', 'template_xidrzss', form.current, 'Yq2ZDevhkqMOXRw34')
      .then((result) => {
        console.log(result.text);
        setSuccessMessage('Email sent successfully!');
        setErrorMessage(null);
      })
      .catch((error) => {
        console.error(error.text);
        setErrorMessage('Error sending email. Please try again.');
        setSuccessMessage(null);
      });
  };

  return (
    <Container className='mb-4'>
      <Card body className='radius-15 text-light bg-black'>
        <Row>
        <Col sm={3}></Col>
          <Col sm={6}>
            <Card body className='radius-15 bg-dark text-light'>
              <h1>Contact Us</h1>
              {successMessage && (
                <Alert variant="success" onClose={() => setSuccessMessage(null)} dismissible>
                  {successMessage}
                </Alert>
              )}
              {errorMessage && (
                <Alert variant="danger" onClose={() => setErrorMessage(null)} dismissible>
                  {errorMessage}
                </Alert>
              )}
              <Form ref={form} onSubmit={sendEmail}>
                <FloatingLabel label="Name">
                  <Form.Control type="text" name="user_name" className='bg-secondary text-light mb-4' placeholder="Enter your name" />
                </FloatingLabel>

                <FloatingLabel label="Email">
                  <Form.Control type="email" name="user_email" className='bg-secondary text-light mb-4' placeholder="Enter your email" />
                </FloatingLabel>

                <FloatingLabel label="Message">
                  <Form.Control as="textarea" name="message" className='bg-secondary text-light mb-4' placeholder="Enter your message" />
                </FloatingLabel>

                <Button variant="outline-light" className='w-100' type="submit">
                  Send
                </Button>
              </Form>
            </Card>
          </Col>
          <Col sm={3}></Col>
        </Row>
      </Card>
    </Container>
  );
};

export default ContactUs;
